/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-17 00:00:00
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Modal, Button, Icon } from '@shopify/polaris';
import { MobileCancelMajor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { routes } from 'src/routes';
import history from 'src/routes/history';
import visualMerchandisingWelcome from 'src/assets/images/dashboard/in-app-popup-sliders/visual-merchandising.png';
import recommendationWelcome from 'src/assets/images/dashboard/in-app-popup-sliders/recommendation.png';
import aiPowerSearchWelcome from 'src/assets/images/dashboard/in-app-popup-sliders/ai-power-search.png';

type Props = {
  active: boolean,
  handleCancel: () => void,
  handleExplore: () => void,
  allowMerchandisingV2: boolean,
  allowSearchV2: boolean,
  allowRecommendation: boolean
};

type ComposedProps = Props & WithI18nProps;
class WelcomeNewMerchandisingModal extends Component<ComposedProps> {
  state = {
    currentSlide: 0,
    features: []
  };

  componentDidMount() {
    const { allowRecommendation, allowMerchandisingV2, allowSearchV2 } = this.props;
    const features = [];
    if (allowRecommendation)
      features.push({
        name: 'recommendation',
        image: recommendationWelcome
      });
    if (allowSearchV2) features.push({ name: 'aiPowerSearch', image: aiPowerSearchWelcome });
    if (allowMerchandisingV2)
      features.push({ name: 'merchandising', image: visualMerchandisingWelcome });
    this.setState({ features });
  }

  componentWillUpdate(nextProps) {
    const { active } = nextProps;
    const { features } = this.state;
    clearTimeout(this.autoDisplay);
    if (active) {
      this.autoDisplay = setTimeout(() => {
        let { currentSlide } = this.state;
        if (currentSlide < features.length - 1) {
          currentSlide += 1;
        } else {
          currentSlide = 0;
        }
        this.setState({ currentSlide });
      }, 3000);
    }
  }

  render() {
    const { currentSlide, features } = this.state;
    const { active, i18n } = this.props;

    // Don't have any feature enabled return ''
    if (features.length === 0) return '';

    const currentFeatureDisplay = features[currentSlide];
    return (
      <div className="">
        <Modal
          open={active}
          onClose={this.handleCancel}
          titleHidden
          noScroll
          title={i18n.translate('AdminHTML.Dashboard.WelcomeNewFeature.merchandising_Title')}>
          <div className="welcome-new-feature">
            <div className="welcome-content">
              <div className="closeBtn">
                <button onClick={this.handleCancel}>
                  <Icon source={MobileCancelMajor} color="base" />
                </button>
              </div>
              <h1 className="Polaris-Heading">
                {i18n.translate(
                  `AdminHTML.Dashboard.WelcomeNewFeature.${currentFeatureDisplay.name}_Title`
                )}
              </h1>
              <h2>
                {i18n.translate(
                  `AdminHTML.Dashboard.WelcomeNewFeature.${currentFeatureDisplay.name}_SubTitle`
                )}
              </h2>

              {/* Image content */}
              <img src={currentFeatureDisplay.image} alt="Empty" />

              <div className="action-sliders">
                {features.map((_, index) => (
                  <div
                    onClick={() => this.setState({ currentSlide: index })}
                    className={`dot-slider ${currentSlide === index ? 'active' : ''}`}
                    key={index}
                  />
                ))}
              </div>
            </div>

            {/* Explore button */}
            <div className="action">
              <Button
                primary
                size="large"
                onClick={() => this.handleExplore(currentFeatureDisplay.name)}>
                {i18n.translate('AdminHTML.Common.Action.explore')}
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }

  handleCancel = () => {
    this.props.onClose();
  };

  handleExplore = name => {
    switch (name) {
      case 'merchandising':
        history.push(
          `${routes.merchandising.view()}?&utm_source=inapp&utm_medium=notification&utm_campaign=BetaLaunch23`
        );
        return;
      case 'aiPowerSearch':
        history.push(
          `${routes.synonym.view()}?&utm_source=inapp&utm_medium=notification&utm_campaign=BetaLaunch23`
        );
        return;
      case 'recommendation':
        history.push(
          `${routes.recommendationWidgets.list()}?&utm_source=inapp&utm_medium=notification&utm_campaign=BetaLaunch23`
        );
        return;
      default:
        return;
    }
  };
}

export default withI18n()(WelcomeNewMerchandisingModal);
